import React from 'react';
import { ButtonContainer } from "./library/Buttons";
import ConfigComponent from "./ConfigComponent";
import Title from './library/Title';

const BaseContent = React.forwardRef(({title, description, imgSrc, disclaimer, secondaryText, actions = [], buttonContainerProps = {}, data = {}, children}, ref) => (
  <>
    <Title><h1><ConfigComponent config={title} /></h1></Title>
    <section className="main" ref={ref}>
      {description && <div className="description"><ConfigComponent config={description} data={data} /></div>}
      {imgSrc && <div className="splash-container"><img className="splash-img" src={imgSrc} alt="" /></div>}
      {(actions.length > 0) && <ButtonContainer {...buttonContainerProps}><ConfigComponent config={actions} /></ButtonContainer>}
      {disclaimer && <ConfigComponent config={disclaimer} />}
      {secondaryText && <div className="description"><ConfigComponent config={secondaryText} /></div>}
      {children}
    </section>
  </>
));

export default BaseContent;
